import FlexPane from './_flex-pane.js'
import SkeletonPart from './_skeleton-part.js'

export default {
  name: 'OpenBetsSkeleton',
  values: {
    numberOfBets: 3,
    showTabs: true,
    container: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          flexDirection: 'column',
          padding: '4px 8px',
        },
      },
    },
    tabsContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexGrow: 0,
          flexBasis: '40px',
          justifyContent: 'space-around',
          alignItems: 'center',
        },
      },
    },
    tabLabel: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          width: '30px',
          height: '14px',
        },
      },
    },
    betContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '18px',
        style: {
          padding: '6px 8px',
          flexDirection: 'column',
          flexBasis: '0px',
        },
      },
    },
    betHeaderContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          flexDirection: 'column',
          justifyContent: 'center',
        },
      },
    },
    betTitleContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          justifyContent: 'space-between',
        },
      },
    },
    betTitlePlaceholder: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          height: '14px',
          width: '52px',
        },
      },
    },
    betDatePlaceholder: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          height: '14px',
          width: '44px',
        },
      },
    },
    betStatusPlaceholder: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          height: '14px',
          width: '72px',
        },
      },
    },
    betInfoContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '0px 8px',
        },
      },
    },
    legStatusIconPlaceholder: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          height: '14px',
          width: '14px',
        },
      },
    },
    selectionNamePlaceholder: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          height: '16px',
          width: '184px',
        },
      },
    },
    labelsContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexDirection: 'column',
          padding: '0px 0px 0px 8px',
        },
      },
    },
    marketNamePlaceholder: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          height: '16px',
          width: '184px',
        },
      },
    },
    eventNamePlaceholder: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          height: '16px',
          width: '140px',
        },
      },
    },
    eventDatePlaceholder: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          height: '16px',
          width: '58px',
        },
      },
    },
    oddsPlaceholder: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          height: '13px',
          width: '28px',
        },
      },
    },
    betFundsInfoContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          flexDirection: 'column',
        },
      },
    },
    stakeInfoContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          justifyContent: 'space-between',
        },
      },
    },
    payoutInfoContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          justifyContent: 'space-between',
        },
      },
    },
    stakeTextPlaceholder: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          height: '13px',
          width: '64px',
        },
      },
    },
    stakeValuePlaceholder: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          height: '13px',
          width: '48px',
        },
      },
    },
    payoutTextPlaceholder: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          height: '13px',
          width: '64px',
        },
      },
    },
    payoutValuePlaceholder: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          height: '13px',
          width: '48px',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
